module.exports = __webpack_public_path__ + "img/interview-sidebar-logo.e33e2982.svg";